"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _toggleOrder = _interopRequireDefault(require("../toggle-order"));

var _flex = _interopRequireDefault(require("../../styles-common/flex"));

var _flexController = _interopRequireDefault(require("../../styles-common/flex-controller"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var InputStyles = {
  control: function control() {
    return {
      display: "flex",
      border: "1px solid rgba(202,204,208,0.85)",
      background: "#FFF",
      borderRadius: "4px",
      padding: "3px 0"
    };
  },
  option: function option(base) {
    return _objectSpread({}, base);
  }
};
var ORDER_TYPES = [{
  label: "Asc",
  value: "asc"
}, {
  label: "Desc",
  value: "desc"
}];

var OrderValues = function OrderValues(_ref) {
  var orderBy = _ref.orderBy,
      columns = _ref.columns,
      setFilters = _ref.setFilters,
      onChange = _ref.onChange;
  var options = columns.map(function (c) {
    return {
      value: c.name,
      label: c.alias || c.name || c.identifier
    };
  });
  var selectedOption = orderBy ? options.find(function (option) {
    return option.value === orderBy.name;
  }) : null;
  var selectedOrder;

  if (orderBy && orderBy.orderType) {
    selectedOrder = ORDER_TYPES.find(function (o) {
      return o.value === orderBy.orderType;
    });
  } else {
    selectedOrder = ORDER_TYPES[0];
  }

  var handleChange = function handleChange(option) {
    var changeOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
    var findSelected = option ? columns.find(function (c) {
      return c.name === option.value;
    }) : {};
    setFilters({
      orderBy: _objectSpread({}, findSelected, {
        orderType: changeOrder || selectedOrder.value
      })
    });
    onChange(_objectSpread({}, findSelected, {
      orderType: changeOrder || findSelected.orderType
    }));
  };

  return _react["default"].createElement(_flex["default"], null, _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-order-title"
  }, "Order by"), _react["default"].createElement(_flex["default"], {
    row: true
  }, _react["default"].createElement(_flexController["default"], {
    contain: 90
  }, _react["default"].createElement(_reactSelect["default"], {
    onChange: function onChange(option) {
      return handleChange(option);
    },
    value: selectedOption,
    options: options,
    styles: InputStyles
  })), _react["default"].createElement(_flexController["default"], {
    contain: 10
  }, _react["default"].createElement(_toggleOrder["default"], {
    options: ORDER_TYPES,
    order: selectedOrder,
    onChange: function onChange(option) {
      handleChange(selectedOption, option.value);
    }
  })))));
};

var _default = OrderValues;
exports["default"] = _default;